// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  BroadcastListInfoResponseDTO,
  BroadcastListsSearchRequestDTO,
  BroadcastListsSearchResponseDTO,
  BroadcastListWriteRequestDTO
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restCreationHandler,
  restDeletionHandler,
  restDetailsHandler,
  restDuplicationHandler,
  restListHandlerPagination,
  restUpdateHandler
} from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const broadcastListUrl = baseUrl + "/broadcastLists/";

export const requestSearchBroadcastLists = createEffect({
  handler: restListHandlerPagination<
    BroadcastListsSearchRequestDTO,
    BroadcastListsSearchResponseDTO
  >(broadcastListUrl + "search")
});

export const requestGetBroadcastList = createEffect({
  handler: restDetailsHandler<BroadcastListInfoResponseDTO>(broadcastListUrl)
});
export const requestCreateBroadcastList = createEffect({
  handler: restCreationHandler<
    BroadcastListWriteRequestDTO,
    BroadcastListInfoResponseDTO
  >(broadcastListUrl)
});

export const requestDuplicateBroadcastList = createEffect({
  handler: restDuplicationHandler<BroadcastListInfoResponseDTO>(
    broadcastListUrl
  )
});

export const requestUpdateBroadcastList = createEffect({
  handler: restUpdateHandler<
    BroadcastListWriteRequestDTO,
    BroadcastListInfoResponseDTO
  >(broadcastListUrl)
});

export const requestDeleteBroadcastList = createEffect({
  handler: restDeletionHandler<BroadcastListInfoResponseDTO>(broadcastListUrl)
});
